import { webCoreTypes } from "@core/core-types.di";
import { FallbackError } from "@core/domain/errors/fallback.error";
import type { IotApiClient } from "@iot-platform/core";
import type { SpatialLevelsDto } from "@station/data/dto/spatial-level.dto";
import { SpatialLevelMapper } from "@station/data/mappers/spatial-level.mapper";
import type { SpatialLevels } from "@station/domain/models/spatial-level.model";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class SpatialLevelDatasource {
    static readonly SPATIAL_LEVEL_PATH = "/spatial_levels";

    constructor(
        @inject(webCoreTypes.infrastructure.IotApiClient)
        private readonly iotApiClient: IotApiClient,
        @inject(SpatialLevelMapper)
        private readonly spatialLevelMapper: SpatialLevelMapper,
    ) {}

    fetchAll(): ResultAsync<SpatialLevels, FallbackError> {
        return this.iotApiClient.http
            .get<SpatialLevelsDto>(SpatialLevelDatasource.SPATIAL_LEVEL_PATH)
            .mapErr(() => new FallbackError())
            .map((response) => this.spatialLevelMapper.mapList(response.data));
    }
}
